export default __webpack_public_path__ + "94f3975666db54e4ffdda7204f1e617b.png";